import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { SuporteTicketsService } from '../../services/suporte-tickets.service';
import { WhatsappService } from '../../services/whatsapp.service';
import { AutorizacaoService } from '../../services/autorizacao.service';

@Component({
  selector: 'app-tickets-suporte',
  templateUrl: './tickets-suporte.component.html',
  styleUrls: ['./tickets-suporte.component.scss']
})
export class TicketsSuporteComponent implements OnInit, OnChanges {
  @Input() empresa: any;
  @Input() grupo: any;
  @Input() contato: any;
  @Input() compacto = false;

  tickets: any[] = [];
  ticketsResolvidosRecentes: any[] = [];
  ticketSelecionado: any;
  responsaveis: any[] = [];
  erro = '';
  erroResolvidosRecentes = '';
  carregando = false;
  carregandoResolvidosRecentes = false;
  salvando = false;
  criando = false;
  novoTicketAberto = false;
  comentarioTexto = '';
  contextoTexto = '';
  arquivoSelecionado: File;
  usuario: any;

  novoTicket: any = this.novoTicketLimpo();

  statusOptions = [
    { valor: 'ABERTO', texto: 'Aberto' },
    { valor: 'EM_ANDAMENTO', texto: 'Em andamento' },
    { valor: 'AGUARDANDO_CLIENTE', texto: 'Aguardando cliente' },
    { valor: 'RESOLVIDO', texto: 'Resolvido' },
    { valor: 'CANCELADO', texto: 'Cancelado' }
  ];

  prioridades = [
    { valor: 'BAIXA', texto: 'Baixa' },
    { valor: 'NORMAL', texto: 'Normal' },
    { valor: 'ALTA', texto: 'Alta' }
  ];

  tiposTicket = [
    { valor: 'PROBLEMA', texto: 'Problema' },
    { valor: 'CONFIGURACAO_CADASTROS', texto: 'Configuracao/Cadastros' },
    { valor: 'DUVIDA', texto: 'Duvida' },
    { valor: 'SUGESTAO_MELHORIA', texto: 'Sugestao de melhoria' },
    { valor: 'CAMPANHA', texto: 'Campanha' },
    { valor: 'IMPRESSORA', texto: 'Impressora' },
    { valor: 'TREINAMENTO', texto: 'Treinamento' },
    { valor: 'IMPLANTACAO', texto: 'Implantacao' },
    { valor: 'OUTRO', texto: 'Outro' }
  ];

  areasSistema = [
    { valor: '', texto: 'Nao informado' },
    { valor: 'PEDIDOS', texto: 'Pedidos' },
    { valor: 'MESAS_COMANDAS', texto: 'Mesas/Comandas' },
    { valor: 'CARDAPIO_PRODUTOS', texto: 'Produtos/Cardapio' },
    { valor: 'LOJA_CONFIGURACOES', texto: 'Loja/Configuracoes' },
    { valor: 'ENTREGA_TAXAS', texto: 'Entrega/Taxas' },
    { valor: 'FORMAS_PAGAMENTO', texto: 'Pagamentos' },
    { valor: 'FISCAL_NOTAS', texto: 'Fiscal/Notas' },
    { valor: 'WHATSAPP', texto: 'WhatsApp' },
    { valor: 'MENSAGENS', texto: 'Mensagens' },
    { valor: 'MARKETING_CAMPANHAS', texto: 'Marketing/Campanhas' },
    { valor: 'CONTATOS_CRM', texto: 'Contatos/CRM' },
    { valor: 'FIDELIDADE', texto: 'Fidelidade' },
    { valor: 'MIA_CHATBOT', texto: 'MIA/Chatbot' },
    { valor: 'IMPRESSAO_KDS', texto: 'Impressao/KDS' },
    { valor: 'INTEGRACOES', texto: 'Integracoes' },
    { valor: 'OUTRO', texto: 'Outro' }
  ];

  constructor(private suporteTicketsService: SuporteTicketsService,
              private whatsappService: WhatsappService,
              private autorizacaoService: AutorizacaoService) {
  }

  ngOnInit() {
    this.usuario = this.autorizacaoService.getUser() || {};
    this.carregueResponsaveis();
    this.carregueTickets();
  }

  ngOnChanges(changes: SimpleChanges) {
    if ((changes.empresa && !changes.empresa.firstChange) || (changes.contato && !changes.contato.firstChange)) {
      this.reinicieEstado();
      this.carregueTickets();
    }
  }

  get empresaId(): number {
    return Number(this.empresa && this.empresa.id);
  }

  get existemTickets(): boolean {
    return this.tickets && this.tickets.length > 0;
  }

  get existemResolvidosRecentes(): boolean {
    return this.ticketsResolvidosRecentes && this.ticketsResolvidosRecentes.length > 0;
  }

  abraNovoTicket() {
    this.novoTicket = this.novoTicketLimpo();
    this.novoTicketAberto = true;
    this.erro = '';
  }

  canceleNovoTicket() {
    this.novoTicketAberto = false;
    this.novoTicket = this.novoTicketLimpo();
  }

  carregueTickets() {
    if (!this.empresaId) {
      return;
    }

    this.carregando = true;
    this.erro = '';
    this.carregueResolvidosRecentes();

    const promessaTickets = this.contato && this.contato.id ?
      this.suporteTicketsService.listeAbertosContato(this.contato.id) :
      this.suporteTicketsService.listeAbertosEmpresa(this.empresaId);

    promessaTickets.then(tickets => {
      this.tickets = tickets || [];

      if (this.ticketSelecionado) {
        const aindaAberto = this.tickets.find(ticket => Number(ticket.id) === Number(this.ticketSelecionado.id));

        if (!aindaAberto && this.statusFechado(this.ticketSelecionado.status)) {
          this.ticketSelecionado = null;
        }
      }
    }).catch(erro => {
      this.erro = erro || 'Nao foi possivel carregar tickets.';
    }).finally(() => {
      this.carregando = false;
    });
  }

  carregueResponsaveis() {
    this.suporteTicketsService.listeResponsaveis().then(responsaveis => {
      this.responsaveis = responsaveis || [];
    }).catch(() => {
      this.responsaveis = [];
    });
  }

  crieTicket() {
    if (!this.empresaId) {
      this.erro = 'Empresa nao informada.';
      return;
    }

    if (!this.novoTicket.titulo || !String(this.novoTicket.titulo).trim()) {
      this.erro = 'Informe o titulo do ticket.';
      return;
    }

    this.criando = true;
    this.erro = '';

    this.suporteTicketsService.crie({
      empresaId: this.empresaId,
      suporteGrupoWhatsappId: this.grupo && this.grupo.id,
      suporteContatoWhatsappId: this.contato && this.contato.id,
      titulo: this.novoTicket.titulo,
      descricao: this.novoTicket.descricao,
      prioridade: this.novoTicket.prioridade,
      tipo: this.novoTicket.tipo,
      tipoOutroDescricao: this.novoTicket.tipoOutroDescricao,
      areaSistema: this.novoTicket.areaSistema,
      responsavelUsuarioId: this.novoTicket.responsavelUsuarioId,
      origem: this.contato && this.contato.id ? 'WHATSAPP_CONTATO' : (this.grupo && this.grupo.id ? 'WHATSAPP' : 'SUPERADMIN')
    }).then(ticket => {
      this.ticketSelecionado = ticket;
      this.novoTicketAberto = false;
      this.novoTicket = this.novoTicketLimpo();
      this.carregueTickets();
    }).catch(erro => {
      this.erro = erro || 'Nao foi possivel criar o ticket.';
    }).finally(() => {
      this.criando = false;
    });
  }

  selecioneTicket(ticket: any) {
    if (!ticket || !ticket.id) {
      return;
    }

    this.salvando = true;
    this.erro = '';

    this.suporteTicketsService.obtenhaTicket(ticket.id).then(ticketCompleto => {
      this.ticketSelecionado = ticketCompleto;
      this.comentarioTexto = '';
      this.contextoTexto = '';
      this.arquivoSelecionado = null;
    }).catch(erro => {
      this.erro = erro || 'Nao foi possivel abrir o ticket.';
    }).finally(() => {
      this.salvando = false;
    });
  }

  mudeStatus(status: string) {
    if (!this.ticketSelecionado || !status) {
      return;
    }

    this.salvando = true;
    this.erro = '';

    this.suporteTicketsService.mudeStatus(this.ticketSelecionado.id, status).then(ticket => {
      this.ticketSelecionado = ticket;
      this.carregueTickets();
    }).catch(erro => {
      this.erro = erro || 'Nao foi possivel alterar o status.';
    }).finally(() => {
      this.salvando = false;
    });
  }

  altereResponsavel(responsavelUsuarioId: number) {
    if (!this.ticketSelecionado) {
      return;
    }

    this.salvando = true;
    this.erro = '';

    this.suporteTicketsService.altereResponsavel(this.ticketSelecionado.id, responsavelUsuarioId).then(ticket => {
      this.ticketSelecionado = ticket;
      this.atualizeTicketNaLista(ticket);
    }).catch(erro => {
      this.erro = erro || 'Nao foi possivel alterar o responsavel.';
    }).finally(() => {
      this.salvando = false;
    });
  }

  carregueResolvidosRecentes() {
    if (!this.empresaId) {
      return;
    }

    this.carregandoResolvidosRecentes = true;
    this.erroResolvidosRecentes = '';

    const filtro: any = {
      empresaId: this.empresaId,
      status: 'RESOLVIDO',
      inicio: 0,
      quantidade: 3
    };

    if (this.contato && this.contato.id) {
      filtro.suporteContatoWhatsappId = this.contato.id;
    } else if (this.grupo && this.grupo.id) {
      filtro.suporteGrupoWhatsappId = this.grupo.id;
    }

    this.suporteTicketsService.liste(filtro).then(retorno => {
      this.ticketsResolvidosRecentes = retorno && retorno.tickets ? retorno.tickets : [];
    }).catch(erro => {
      this.erroResolvidosRecentes = erro || 'Nao foi possivel carregar tickets resolvidos recentes.';
    }).finally(() => {
      this.carregandoResolvidosRecentes = false;
    });
  }

  assumaTicket() {
    if (!this.ticketSelecionado) {
      return;
    }

    this.salvando = true;
    this.erro = '';

    this.suporteTicketsService.assuma(this.ticketSelecionado.id).then(ticket => {
      this.ticketSelecionado = ticket;
      this.atualizeTicketNaLista(ticket);
    }).catch(erro => {
      this.erro = erro || 'Nao foi possivel assumir o ticket.';
    }).finally(() => {
      this.salvando = false;
    });
  }

  podeAssumirTicket(): boolean {
    if (!this.ticketSelecionado || !this.usuario || !this.usuario.id) {
      return false;
    }

    if (this.statusFechado(this.ticketSelecionado.status)) {
      return false;
    }

    return Number(this.ticketSelecionado.responsavelUsuarioId || 0) !== Number(this.usuario.id || 0);
  }

  salveClassificacao() {
    if (!this.ticketSelecionado) {
      return;
    }

    this.salvando = true;
    this.erro = '';

    this.suporteTicketsService.atualize({
      id: this.ticketSelecionado.id,
      titulo: this.ticketSelecionado.titulo,
      descricao: this.ticketSelecionado.descricao,
      prioridade: this.ticketSelecionado.prioridade,
      tipo: this.ticketSelecionado.tipo,
      tipoOutroDescricao: this.ticketSelecionado.tipoOutroDescricao,
      areaSistema: this.ticketSelecionado.areaSistema,
      responsavelUsuarioId: this.ticketSelecionado.responsavelUsuarioId
    }).then(ticket => {
      this.ticketSelecionado = ticket;
      this.atualizeTicketNaLista(ticket);
    }).catch(erro => {
      this.erro = erro || 'Nao foi possivel salvar a classificacao.';
    }).finally(() => {
      this.salvando = false;
    });
  }

  adicioneComentario() {
    this.adicioneInteracao(this.comentarioTexto, 'COMENTARIO');
  }

  adicioneContexto() {
    this.adicioneInteracao(this.contextoTexto, 'CONTEXTO');
  }

  selecioneArquivo(event: any) {
    const files = event && event.target && event.target.files;
    this.arquivoSelecionado = files && files.length ? files[0] : null;
  }

  envieAnexo() {
    if (!this.ticketSelecionado || !this.arquivoSelecionado) {
      return;
    }

    this.salvando = true;
    this.erro = '';

    this.suporteTicketsService.adicioneAnexo(this.ticketSelecionado.id, this.arquivoSelecionado).then(ticket => {
      this.ticketSelecionado = ticket;
      this.arquivoSelecionado = null;
      this.atualizeTicketNaLista(ticket);
    }).catch(erro => {
      this.erro = erro || 'Nao foi possivel anexar o print.';
    }).finally(() => {
      this.salvando = false;
    });
  }

  textoStatus(status: string): string {
    const opcao = this.statusOptions.find(item => item.valor === status);
    return opcao ? opcao.texto : status;
  }

  textoPrioridade(prioridade: string): string {
    const opcao = this.prioridades.find(item => item.valor === prioridade);
    return opcao ? opcao.texto : prioridade;
  }

  textoTipo(tipo: string, tipoOutroDescricao?: string): string {
    if (tipo === 'OUTRO' && tipoOutroDescricao) {
      return 'Outro: ' + tipoOutroDescricao;
    }

    const opcao = this.tiposTicket.find(item => item.valor === tipo);
    return opcao ? opcao.texto : (tipo || 'Problema');
  }

  textoArea(areaSistema: string): string {
    const opcao = this.areasSistema.find(item => item.valor === areaSistema);
    return opcao ? opcao.texto : 'Nao informado';
  }

  textoTipoAtendimento(tipo: string): string {
    const mapa: any = {
      CRIACAO: 'Criacao',
      ASSUMIDO: 'Assumiu',
      TRANSFERIDO: 'Transferido',
      IMPORTADO: 'Importado'
    };

    return mapa[tipo] || tipo;
  }

  textoDuracaoAtendimento(atendimento: any): string {
    const minutos = Number(atendimento && atendimento.duracaoMinutos);

    if (!Number.isFinite(minutos)) {
      return 'Tempo nao informado';
    }

    if (minutos < 60) {
      return minutos + 'min';
    }

    const horas = Math.floor(minutos / 60);
    const minutosRestantes = minutos % 60;

    return horas + 'h' + (minutosRestantes ? ' ' + minutosRestantes + 'min' : '');
  }

  classePrioridade(prioridade: string): string {
    const mapa: any = {
      BAIXA: 'ticket-prioridade-baixa',
      NORMAL: 'ticket-prioridade-normal',
      ALTA: 'ticket-prioridade-alta'
    };

    return mapa[prioridade] || '';
  }

  textoIdade(ticket: any): string {
    const horas = this.idadeTicketEmHoras(ticket);

    if (horas == null) {
      return 'Idade nao informada';
    }

    if (horas < 1) {
      return 'Criado ha menos de 1h';
    }

    if (horas < 24) {
      return 'Criado ha ' + horas + 'h';
    }

    const dias = Math.floor(horas / 24);
    const horasRestantes = horas % 24;

    return 'Criado ha ' + dias + 'd' + (horasRestantes ? ' ' + horasRestantes + 'h' : '');
  }

  classeIdade(ticket: any): string {
    const horas = this.idadeTicketEmHoras(ticket);

    if (horas == null) {
      return '';
    }

    if (horas >= 168) {
      return 'ticket-idade-critica';
    }

    if (horas >= 72) {
      return 'ticket-idade-alerta';
    }

    return '';
  }

  abraGrupoTicket(ticket: any) {
    const chatId = this.obtenhaGrupoWhatsappChatId(ticket);

    if (!chatId) {
      return;
    }

    this.whatsappService.abraConversa(chatId);
  }

  podeAbrirGrupoTicket(ticket: any): boolean {
    return !!this.obtenhaGrupoWhatsappChatId(ticket);
  }

  private obtenhaGrupoWhatsappChatId(ticket: any): string {
    return (ticket && ticket.grupoWhatsappChatId) || (this.grupo && this.grupo.whatsappChatId) || '';
  }

  private idadeTicketEmHoras(ticket: any): number | null {
    if (!ticket || !ticket.dataCriacao) {
      return null;
    }

    const dataCriacao = new Date(ticket.dataCriacao).getTime();

    if (!dataCriacao) {
      return null;
    }

    return Math.max(0, Math.floor((Date.now() - dataCriacao) / (1000 * 60 * 60)));
  }

  private adicioneInteracao(texto: string, tipo: string) {
    if (!this.ticketSelecionado) {
      return;
    }

    if (!texto || !String(texto).trim()) {
      this.erro = tipo === 'CONTEXTO' ? 'Informe o contexto do ticket.' : 'Informe o comentario.';
      return;
    }

    this.salvando = true;
    this.erro = '';

    this.suporteTicketsService.adicioneInteracao(this.ticketSelecionado.id, texto, tipo).then(ticket => {
      this.ticketSelecionado = ticket;
      this.comentarioTexto = tipo === 'COMENTARIO' ? '' : this.comentarioTexto;
      this.contextoTexto = tipo === 'CONTEXTO' ? '' : this.contextoTexto;
      this.atualizeTicketNaLista(ticket);
    }).catch(erro => {
      this.erro = erro || 'Nao foi possivel registrar a informacao.';
    }).finally(() => {
      this.salvando = false;
    });
  }

  private atualizeTicketNaLista(ticket: any) {
    const index = this.tickets.findIndex(item => Number(item.id) === Number(ticket.id));

    if (index >= 0) {
      if (this.statusFechado(ticket.status)) {
        this.tickets.splice(index, 1);
      } else {
        this.tickets[index] = ticket;
      }
    }
  }

  private statusFechado(status: string): boolean {
    return status === 'RESOLVIDO' || status === 'CANCELADO';
  }

  private reinicieEstado() {
    this.tickets = [];
    this.ticketsResolvidosRecentes = [];
    this.ticketSelecionado = null;
    this.erro = '';
    this.erroResolvidosRecentes = '';
    this.novoTicketAberto = false;
    this.novoTicket = this.novoTicketLimpo();
    this.comentarioTexto = '';
    this.contextoTexto = '';
    this.arquivoSelecionado = null;
    this.carregandoResolvidosRecentes = false;
  }

  private novoTicketLimpo(): any {
    return {
      titulo: '',
      descricao: '',
      prioridade: 'NORMAL',
      tipo: 'PROBLEMA',
      tipoOutroDescricao: '',
      areaSistema: '',
      responsavelUsuarioId: null
    };
  }
}
